function isPrivateImageHost(hostname) {
  const host = hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || host === '::1') return true;
  if (host.startsWith('10.') || host.startsWith('192.168.') || host.startsWith('169.254.')) return true;

  const match172 = host.match(/^172\.(\d+)\./);
  return Boolean(match172 && Number(match172[1]) >= 16 && Number(match172[1]) <= 31);
}

export function displayImageUrl(stoneOrUrl) {
  const raw = typeof stoneOrUrl === 'string'
    ? stoneOrUrl
    : (stoneOrUrl?.photo || stoneOrUrl?.sourceImageUrl || '');

  if (!raw) return '';

  try {
    const url = new URL(raw);
    if (isPrivateImageHost(url.hostname)) {
      return '';
    }
    if (url.hostname === 't.990g.com') {
      return `/api/image-proxy?url=${encodeURIComponent(url.toString())}`;
    }
  } catch (_) {
    return raw;
  }

  return raw;
}
